"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.phoneNumberSchema = phoneNumberSchema;
exports.phoneInputSchema = phoneInputSchema;
const zod_1 = require("zod");
const REGEX_PHONE = /^(\+)?([0-9\s()-]*)(((x|ext|EXT)(=|\s)?)?([0-9]{1,5}))$/i;
function phoneNumberSchema({ translations }) {
    return zod_1.z.preprocess(value => (value === '' ? null : value), zod_1.z
        .string()
        .max(50, translations.maxCharsN(50, 'phoneNumber'))
        .regex(REGEX_PHONE, translations.invalidPhoneForField('phoneNumber'))
        .nullish());
}
function phoneInputSchema({ translations }) {
    return zod_1.z.object({
        phoneNumber: phoneNumberSchema({ translations }),
    });
}
//# sourceMappingURL=phone.js.map